module.exports = __webpack_public_path__ + "img/menunggu_verifikasi.c00ea4b7.svg";